<div *ngIf="!credential; else preIssue" fxLayout="row">
  <mat-icon class="error">cancel</mat-icon><span class="ml-1 bold">{{ credentialName }} never issued</span>
</div>
<ng-template #preIssue>
  <div *ngIf="credential.status === 'PreIssue'; else nonPreIssue" fxLayout="row">
    <mat-icon class="warning">warning</mat-icon
    ><span class="ml-1 bold">{{ credential.credentialName }} scenario in progress</span>
  </div>
</ng-template>
<ng-template #nonPreIssue>
  <div fxFlex fxLayout="column">
    <span class="title">{{ credential.credentialName }}</span>
    <span class="subtitle" *ngIf="credential.credentialNumber">{{ credential.credentialNumber }}</span>
  </div>

  <div class="card-text">
    <span
      >{{ credential.credentialStartDate | localDate: 'MMM DD, YYYY' }}
      {{ credential.credentialStartDate && credential.credentialEndDate ? '-' : '' }}
      {{ credential.credentialEndDate | localDate: 'MMM DD, YYYY' }}
      <span *ngIf="credential.isRenewalAvailable" class="bold">Renewal Available</span>
      <span *ngIf="credential.isReinstatementAvailable" class="bold">Reinstatement Available</span>
    </span>
  </div>
  <div fxFlex="10" fxLayout="row" fxLayoutAlign="end center">
    <span class="credential-status">
      <svg width="15" height="10">
        <circle
          [ngClass]="CredentialStatusLabelColor[credential.customPersonCredentialStatusDefinition.color]"
          class="status-dot"
          cx="5"
          cy="5"
          r="4"
          stroke-width="0"
        />
      </svg>
      <span class="title">{{ credential.customPersonCredentialStatusDefinition.label }}</span></span
    >
  </div>
  <ng-content></ng-content>
</ng-template>
